(function(){
  var SABER_RESULTS = {
    "Dark Side": {
      sabers: ["Nova","Eclipse","Dauntless","Retribution","Sentinel","Arc","Polaris","Knight","Incursion"],
      bladeColors: [{ name: "Red", hex: "#ff2a2a" }],
      description: {
        identity: "You act quickly, trust instinct, and push forward when others hesitate. Power, pressure, and momentum do not intimidate you — they sharpen you.",
        strengths: ["Decisive under pressure","Fearless in conflict","Commanding presence"],
        weakness: "Your biggest challenge is restraint. When you move too fast or burn too hot, discipline becomes the difference between control and chaos.",
        meaning: "Your choices show a personality driven by intensity, ambition, and force of will. You are built to lead, but your greatest strength is learning when to hold that power back."
      }
    },
    "Light Side": {
      sabers: ["Paragon","Vega","Revenant","Paladin","Legacy","Heirloom","Zeta","Insurgent","Enlightened","Wisdom","Pathfinder"],
      bladeColors: [{ name: "Blue", hex: "#00aaff" }, { name: "Green", hex: "#3ddc84" }],
      description: {
        identity: "You value clarity, discipline, and purpose. You do not rush blindly — you read the moment, hold your ground, and act with intention.",
        strengths: ["Calm under pressure","Strategic thinker","Strong moral compass"],
        weakness: "Your biggest challenge is hesitation. In trying to choose the right path, you can sometimes delay the action the moment demands.",
        meaning: "Your choices show a personality shaped by control, principle, and measured strength. You lead best when your confidence matches your discipline."
      }
    },
    "Balanced": {
      sabers: ["Excalibur","Atlas","Athena","Resistance","Divergent","Regent","Aether","Highcrest"],
      bladeColors: [{ name: "Purple", hex: "#a855f7" }, { name: "Yellow", hex: "#ffd84d" }],
      description: {
        identity: "You are adaptable, difficult to predict, and not easily defined by one path. You see multiple sides clearly and thrive when others are forced into extremes.",
        strengths: ["Adaptable in any situation","Sees both sides clearly","Unpredictable edge"],
        weakness: "Your biggest challenge is direction. Because you understand so many possibilities, choosing one clear path can be harder than it looks.",
        meaning: "Your choices show someone who values freedom, flexibility, and perspective. You are strongest when you stop waiting for certainty and trust your own center."
      }
    }
  };

  var PROMPTS = [
    { q: "A frightened village asks for aid while your own mission hangs in the balance. What do you do?", a: [{ t: "Protect the village first, no matter the delay.", v: "Light Side" }, { t: "Stay on mission. Weakness can wait.", v: "Dark Side" }, { t: "Secure the mission while minimizing harm to both.", v: "Balanced" }]},
    { q: "A rival insults you before a crowd of allies. Your response?", a: [{ t: "Remain composed and let discipline speak for you.", v: "Light Side" }, { t: "Break their pride immediately and publicly.", v: "Dark Side" }, { t: "Turn the moment to your advantage with calm pressure.", v: "Balanced" }]},
    { q: "You discover forbidden knowledge hidden in a ruined archive.", a: [{ t: "Seal it away if it threatens others.", v: "Light Side" }, { t: "Take it. Power belongs to the bold.", v: "Dark Side" }, { t: "Study it carefully and decide later.", v: "Balanced" }]},
    { q: "A teammate fails and puts everyone at risk.", a: [{ t: "Lift them up and help them recover.", v: "Light Side" }, { t: "Remove them before they fail again.", v: "Dark Side" }, { t: "Keep them close, but under your watch.", v: "Balanced" }]},
    { q: "An enemy surrenders after a brutal duel.", a: [{ t: "Accept surrender and show mercy.", v: "Light Side" }, { t: "Finish it. Mercy invites betrayal.", v: "Dark Side" }, { t: "Spare them if it serves a larger purpose.", v: "Balanced" }]},
    { q: "You are offered command over a powerful order.", a: [{ t: "Lead to protect and serve others.", v: "Light Side" }, { t: "Lead so no one can challenge you.", v: "Dark Side" }, { t: "Lead only if it grants freedom to act your way.", v: "Balanced" }]},
    { q: "A mysterious force calls you into the unknown.", a: [{ t: "Follow it with faith and restraint.", v: "Light Side" }, { t: "Seize it before anyone else can.", v: "Dark Side" }, { t: "Test it first and trust your own judgment.", v: "Balanced" }]},
    { q: "During battle, rules prevent the fastest victory.", a: [{ t: "Hold to the code. Victory without honor is hollow.", v: "Light Side" }, { t: "Discard the rules and win at any cost.", v: "Dark Side" }, { t: "Bend the rules only as far as needed.", v: "Balanced" }]},
    { q: "You find an ancient saber with a dangerous past.", a: [{ t: "Preserve it carefully and learn its history.", v: "Light Side" }, { t: "Claim it. Dark legends only make it stronger.", v: "Dark Side" }, { t: "Use it if it proves worthy in your hands.", v: "Balanced" }]},
    { q: "Your closest ally hides the truth from you.", a: [{ t: "Seek understanding before judgment.", v: "Light Side" }, { t: "Make them regret the deception.", v: "Dark Side" }, { t: "Use the truth when it becomes useful.", v: "Balanced" }]},
    { q: "You stand before a defeated tyrant's throne.", a: [{ t: "Destroy it and free the people.", v: "Light Side" }, { t: "Take the throne and rule harder.", v: "Dark Side" }, { t: "Use the throne until it no longer serves you.", v: "Balanced" }]},
    { q: "A master tells you to be patient when you crave action.", a: [{ t: "Patience is part of strength.", v: "Light Side" }, { t: "Waiting is for the weak.", v: "Dark Side" }, { t: "Wait only if it creates an advantage.", v: "Balanced" }]},
    { q: "You can save one priceless relic or one stranger.", a: [{ t: "Save the stranger without hesitation.", v: "Light Side" }, { t: "Take the relic. Power changes everything.", v: "Dark Side" }, { t: "Judge which one shifts the future more.", v: "Balanced" }]},
    { q: "The path ahead splits into safety, conquest, and uncertainty.", a: [{ t: "Choose the path that protects the most people.", v: "Light Side" }, { t: "Choose conquest. Fear clears the way.", v: "Dark Side" }, { t: "Choose uncertainty. Freedom lies there.", v: "Balanced" }]},
    { q: "A duel is moments away. How do you center yourself?", a: [{ t: "Breathe, focus, and let discipline guide you.", v: "Light Side" }, { t: "Feed the fire and strike with overwhelming force.", v: "Dark Side" }, { t: "Read the field and adapt before the first move.", v: "Balanced" }]}
  ];

  var state = { prompts: [], index: 0, answers: [], result: null };

  function shuffle(arr){
    var copy = arr.slice();
    for(var i = copy.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = copy[i];
      copy[i] = copy[j];
      copy[j] = tmp;
    }
    return copy;
  }

  function saberHandle(name){
    return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '-v3';
  }


  function chooseSaber(alignment){
    var bucket = SABER_RESULTS[alignment];
    return bucket.sabers[Math.floor(Math.random() * bucket.sabers.length)];
  }

  function chooseCloak(alignment){
    if(alignment === "Dark Side") return "Void (Black)";
    if(alignment === "Light Side") return Math.random() < 0.7 ? "Elderwood (Brown)" : "Snow (White)";
    return Math.random() < 0.8 ? "Crimson Dusk (Burgundy)" : "Snow (White)";
  }

  function chooseBladeColor(alignment){
    var bucket = SABER_RESULTS[alignment];
    return bucket.bladeColors[Math.floor(Math.random() * bucket.bladeColors.length)];
  }

  function resetShellStyle(){
    var shell = document.querySelector('.quiz-shell');
    if(shell){
      shell.style.boxShadow = '';
      shell.style.borderColor = '';
      shell.style.setProperty('--quiz-accent', '#00aaff');
      shell.style.setProperty('--quiz-accent-soft', 'rgba(0,170,255,0.18)');
      shell.style.setProperty('--quiz-accent-strong', 'rgba(0,170,255,0.35)');
    }
  }

function startQuiz(){
    state.prompts = shuffle(PROMPTS).slice(0, 15);
    state.index = 0;
    state.answers = new Array(15);
    state.result = null;

    var intro = document.getElementById('quizIntro');
    var stage = document.getElementById('quizStage');
    var result = document.getElementById('quizResult');
    var heading = document.querySelector('.section-heading');  // ADD THIS

    if(intro) intro.hidden = true;
    if(stage) stage.hidden = false;
    if(result) result.hidden = true;
    if(heading) heading.hidden = true;  // ADD THIS

    resetShellStyle();
    renderQuestion();
  }


  function renderQuestion(){
    var prompt = state.prompts[state.index];
    if(!prompt) return;

    var question = document.getElementById('quizQuestion');
    var answers = document.getElementById('quizAnswers');
    var current = document.getElementById('quizCurrentStep');
    var fill = document.getElementById('quizProgressFill');
    var next = document.getElementById('quizNextBtn');
    var back = document.getElementById('quizBackBtn');

    if(question) question.textContent = prompt.q;
    if(current) current.textContent = String(state.index + 1);
    if(fill) fill.style.width = (((state.index + 1) / 15) * 100) + '%';
    if(next) next.textContent = state.index === 14 ? 'Reveal My Path' : 'Next';
    if(back) back.disabled = state.index === 0;

    if(answers){
      var html = '';
      for(var i = 0; i < prompt.a.length; i++){
        var selected = state.answers[state.index] === prompt.a[i].v ? ' is-active' : '';
        html += '<button type="button" class="quiz-answer' + selected + '" data-answer-value="' + prompt.a[i].v + '">' + prompt.a[i].t + '</button>';
      }
      answers.innerHTML = html;
    }
  }

  function revealResult(){
    if(state.result){
      renderResult(state.result);
      return;
    }

    var scores = { "Light Side": 0, "Dark Side": 0, "Balanced": 0 };
    for(var i = 0; i < state.answers.length; i++){
      if(scores[state.answers[i]] !== undefined){
        scores[state.answers[i]] += 1;
      }
    }

    var alignment = "Light Side";
    if(scores["Dark Side"] > scores["Light Side"] && scores["Dark Side"] >= scores["Balanced"]){
      alignment = "Dark Side";
    } else if(scores["Balanced"] > scores["Light Side"] && scores["Balanced"] >= scores["Dark Side"]){
      alignment = "Balanced";
    }

    state.result = {
      alignment: alignment,
      saber: chooseSaber(alignment),
      cloak: chooseCloak(alignment),
      blade: chooseBladeColor(alignment),
      data: SABER_RESULTS[alignment]
    };

    renderResult(state.result);
  }

  function renderResult(resultObj){
    var stage = document.getElementById('quizStage');
    var result = document.getElementById('quizResult');
    if(stage) stage.hidden = true;
    if(result) result.hidden = false;

    document.getElementById('quizResultSaber').textContent = resultObj.saber;
    document.getElementById('quizResultAlignment').textContent = resultObj.alignment;
    document.getElementById('quizResultBladeColor').textContent = 'Blade Color: ' + resultObj.blade.name;
    document.getElementById('quizResultCloak').textContent = 'Cloak: ' + resultObj.cloak;
    document.getElementById('quizResultIdentity').textContent = resultObj.data.description.identity;
    document.getElementById('quizResultWeakness').textContent = resultObj.data.description.weakness;
    document.getElementById('quizResultMeaning').textContent = resultObj.data.description.meaning;

    var strengths = document.getElementById('quizResultStrengths');
    strengths.innerHTML = resultObj.data.description.strengths.map(function(item){
      return '<li>' + item + '</li>';
    }).join('');

    var shell = document.querySelector('.quiz-shell');
    if(shell){
      shell.style.borderColor = resultObj.blade.hex;
      shell.style.boxShadow = '0 0 0 1px rgba(255,255,255,0.06), 0 18px 40px rgba(0,0,0,0.25), 0 0 30px ' + resultObj.blade.hex + '40';
      shell.style.setProperty('--quiz-accent', resultObj.blade.hex);
      shell.style.setProperty('--quiz-accent-soft', resultObj.blade.hex + '22');
      shell.style.setProperty('--quiz-accent-strong', resultObj.blade.hex + '55');
    }

    var claim = document.getElementById('quizClaimBtn');
    if(claim){
      claim.href = '/products/' + saberHandle(resultObj.saber);
    }
  }

  document.addEventListener('click', function(e){
    var start = e.target.closest('#quizStartBtn');
    if(start){
      startQuiz();
      return;
    }

    var answer = e.target.closest('[data-answer-value]');
    if(answer){
      state.answers[state.index] = answer.getAttribute('data-answer-value');
      var buttons = document.querySelectorAll('[data-answer-value]');
      for(var i = 0; i < buttons.length; i++){
        buttons[i].classList.remove('is-active');
      }
      answer.classList.add('is-active');
      return;
    }

    var back = e.target.closest('#quizBackBtn');
    if(back){
      if(state.index > 0){
        state.index -= 1;
        renderQuestion();
      }
      return;
    }

    var next = e.target.closest('#quizNextBtn');
    if(next){
      if(!state.answers[state.index]){
        var first = document.querySelector('[data-answer-value]');
        if(first){
          state.answers[state.index] = first.getAttribute('data-answer-value');
          first.classList.add('is-active');
        } else {
          return;
        }
      }
      if(state.index < 14){
        state.index += 1;
        renderQuestion();
      } else {
        revealResult();
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function(){
    resetShellStyle();
  });
})();
